export function getUrlParam(paramName: string): string {
  /*
   * https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
   *   return urlParams.get(paramName) ?? '';
   */
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName) ?? '';
  }
  return '';
}

const pkgFromURL = getUrlParam('pkg') || '';

// TODO: UAP_SIT temporarily points to beta CIS instance until a dedicated CIS SIT instance is available
export const betaCisAllowedPkgs = ['UAP_UAT', 'UAP_SIT'];
export const clientIntegrationSvcBaseUrl = betaCisAllowedPkgs.includes(pkgFromURL)
  ? '/client-integration-svc-beta'
  : '/client-integration-svc';
